import type {AppBaseModalPlacement} from "../../BaseModal.types";

type WrapperPlacement =
  "top-left" | "top" | "top-right" |
  "left" | "center" | "right" |
  "bottom-left" | "bottom" | "bottom-right";

export const getWrapperPlacement = (placement: AppBaseModalPlacement): WrapperPlacement => {
  return placement.replace(/[A-Z]/, (match) => "-" + match.toLowerCase()) as WrapperPlacement;
};